import ControlledTextAreaField from 'views/components/common/Form/ReactForm/ControlledTextAreaField/ControlledTextAreaField';

export default ControlledTextAreaField;
